import React from 'react'
import { Link } from 'react-router-dom';

function Nav(){
    return(
        <div>
            <div className="header-nav main-nav-one">
                <nav>
                    <ul style={{marginBottom:"10px"}} className="parent-nav">
                        <li>
                            <Link  className="nav-link" to="/home-two">
                                <span><div className="block"><span className="letter">H</span><span className="letter">O</span><span className="letter">M</span><span className="letter">E</span></div></span>
                            </Link>
                            {/* <ul className="submenu mega-menu-wrapper">
                                <li className="menu-single-list">
                                    <ul>
                                        <li><Link to="/" className="active">Corporate Demo</Link></li>
                                        <li><Link to="/home-two">Financial Demo</Link></li>
                                        <li><Link to="/home-three">Marketing Demo</Link></li>
                                        <li><Link to="/home-four">Agency Demo</Link></li>
                                        <li><Link to="/home-five">Startup Demo</Link></li>
                                        <li><Link to="/home-six">Construction Demo</Link></li>
                                        <li><Link to="/home-seven">Construction 2 Demo</Link></li>
                                        <li><Link to="/home-eight">Company Demo</Link></li>
                                    </ul>
                                </li>
                            </ul> */}
                        </li>
                        <li>
                            <Link className="nav-link" to="/About">
                                <span><div className="block"><span className="letter">A</span><span className="letter">B</span><span className="letter">O</span><span className="letter">U</span><span className="letter">T</span></div></span>
                            </Link>
                        </li>
                        <li className="">
                            <Link className="nav-link" to="/ServiceDetails">
                                <span><div className="block"><span className="letter">S</span><span className="letter">E</span><span className="letter">R</span><span className="letter">V</span><span className="letter">I</span><span className="letter">C</span><span className="letter">E</span><span className="letter">S</span></div></span>
                            </Link>
                            {/* <ul className="submenu">
                                <li><Link to="/Service">Service</Link></li>
                                <li><Link to="/ServiceDetails">Service Details</Link></li>
                            </ul> */}
                        </li>
                        {/* <li className="has-dropdown">
                            <Link className="nav-link" to="#">
                                <span className="rolling-text"><div className="block"><span className="letter">B</span><span className="letter">L</span><span className="letter">O</span><span className="letter">G</span></div><div className="block"><span className="letter">B</span><span className="letter">L</span><span className="letter">O</span><span className="letter">G</span></div></span>
                            </Link>
                            <ul className="submenu">
                                <li><Link to="/Blog">Blog</Link></li>
                                <li><Link to="/BlogColOne">Blog Col 1</Link></li>
                                <li><Link to="/BlogColTwo">Blog Col 2</Link></li>
                                <li><Link to="/BlogDetails">Blog Details</Link></li>
                                <li><Link to="/BlogDetailsTwo">Blog Details v2</Link></li>
                            </ul>
                        </li> */}
                        {/* <li className="has-dropdown">
                            <Link className="nav-link" to="#">
                                <span className="rolling-text"><div className="block"><span className="letter">P</span><span className="letter">A</span><span className="letter">G</span><span className="letter">E</span><span className="letter">S</span></div><div className="block"><span className="letter">P</span><span className="letter">A</span><span className="letter">G</span><span className="letter">E</span><span className="letter">S</span></div></span>
                            </Link>
                            <ul className="submenu">
                                <li><Link to="/Appoinment">Appoinment</Link></li>
                                <li><Link to="/Project">Project</Link></li>
                                <li><Link to="/ProjectMesonary">Project Mesonary</Link></li>
                                <li><Link to="/ProjectMesonaryThree">Project Mesonary v2</Link></li>
                                <li><Link to="/ProjectSlider">Project Slider</Link></li>
                                <li><Link to="/ProjectDetails">Project Details</Link></li>
                                <li><Link to="/ProjectDetailsTwo">Project Details v2</Link></li>
                                <li><Link to="/TeamOne">Team</Link></li>
                                <li><Link to="/TeamTwo">Team Two</Link></li>
                                <li><Link to="/TeamDetails">Team Details</Link></li>
                                <li><Link to="/Pricing">Pricing</Link></li>
                                <li><Link to="/FaqOne">Faq</Link></li>
                                <li><Link to="/Error">Error</Link></li>
                            </ul>
                        </li> */}

                         <li>
                            <Link className="nav-link" to="/Project">
                                <span><div className="block"><span className="letter">G</span><span className="letter">A</span><span className="letter">L</span><span className="letter">L</span><span className="letter">E</span><span className="letter">R</span><span className="letter">Y</span></div></span>
                            </Link>
                        </li>
                         <li>
                            <Link className="nav-link" to="/ProjectDetails">
                                <span><div className="block"><span className="letter">S</span><span className="letter">O</span><span className="letter">L</span><span className="letter">U</span><span className="letter">T</span><span className="letter">I</span><span className="letter">O</span><span className="letter">N</span><span className="letter">S</span></div></span>
                            </Link>
                        </li>
                        <li>
                            <Link className="nav-link" to="/Contact">
                                <span><div className="block"><span className="letter">C</span><span className="letter">O</span><span className="letter">N</span><span className="letter">T</span><span className="letter">A</span><span className="letter">C</span><span className="letter">T</span></div></span>
                            </Link>
                        </li>
                    </ul>
                </nav>
            </div>
        </div>
    )
}


export default Nav